import { ParamsProps } from '@pruforce/common-adminweb-sdk';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { PaginateList, PaginateResultMore } from 'src/app/common/types';
import { getRangeDate, useDataProvider } from 'src/app/common/utils';
import { getSpecialDays } from 'src/app/modules/Event/network/specialDayCrud';
import { SpecialDayItem, SpecialDayListParam } from 'src/app/modules/Event/types/special-day-type';

const initialState: SpecialDayListParam = {
  pageNum: 1,
  pageSize: 10,
  name: '',
  status: '',
  toDate: null,
  fromDate: null,
  descSortItems: 'createdAt',
  sortItem: 'createdAt',
  sortOrder: 'desc',
};

const paramsInitiator = (initialParams?: Record<string, any>): SpecialDayListParam => {
  return initialParams
    ? {
        pageNum: initialParams.pageNum ?? 1,
        pageSize: initialParams.pageSize ?? 10,
        name: initialParams.name || '',
        status: initialParams.status || '',
        descSortItems: 'createdAt',
        sortItem: 'createdAt',
        sortOrder: 'desc',
        ...getRangeDate(initialParams.fromDate || null, initialParams.toDate || null),
      }
    : initialState;
};

export const useSpecialDayListing = ({ initialParams, onChangeQueryParams }: ParamsProps) => {
  const dispatch = useDispatch();
  const [filterState, setFilterState] = useState<SpecialDayListParam>(paramsInitiator(initialParams));
  const [specialDayList, setSpecialDayList] = useState<PaginateResultMore<SpecialDayItem>>();

  const { isLoading, refreshData } = useDataProvider<PaginateResultMore<SpecialDayItem>>(
    async () => {
      try {
        if (onChangeQueryParams) {
          onChangeQueryParams(filterState);
        }

        return await getSpecialDays(filterState, dispatch);
      } catch (err) {}
    },
    setSpecialDayList,
    false,
  );

  return {
    filterState,
    specialDayList,
    isLoading,
    setFilterState,
    refreshData,
  };
};
